class LeftPanelMenu {
    constructor() {
        this.isNavOpen = false;
    }

    init() {
        const gNavRoot = document.getElementById('js-gNav');
        const gNavOpener = document.getElementById('gNavOpener');
        const gNav = document.getElementById('gNav');

        if (!document.body.classList.contains('noGnav') && (!gNavRoot || !gNavOpener || !gNav)) {
            return;
        }

        if (!document.body.classList.contains('noGnav')) {
            this.initMegaMenu();
            if (util.isRespMode) {
              this.addSpMenu();
            }
        }
        // FocusLoop
        const focusLoop = gNavRoot ? new azlib.FocusLoop('#js-gNav') : null;


        /**
        ********************************************
        * click event
        ********************************************
        */
        if (!document.body.classList.contains('noGnav')) {
            gNavOpener.addEventListener('click', (e) => {
              if (this.isNavOpen) {
                e.currentTarget.setAttribute('aria-expanded', false);
                gNav.setAttribute('aria-hidden', true);
                e.currentTarget.setAttribute('aria-label', e.currentTarget.dataset.labelOpen);
                document.body.classList.remove('open');
                this.isNavOpen = false;
                //FocusLoop
                if (focusLoop) {
                    focusLoop.isRun = false;
                }
              } else {
                e.currentTarget.setAttribute('aria-expanded', true);
                gNav.setAttribute('aria-hidden', false);
                e.currentTarget.setAttribute('aria-label', e.currentTarget.dataset.labelClose);
                document.body.classList.add('open');
                this.isNavOpen = true;
                //FocusLoop
                if (focusLoop) {
                    focusLoop.isRun = true;
                }
              }
            });

            document.addEventListener('keydown', (e) => {
                if (this.isNavOpen) {
                    if (e.key === 'Escape') {
                        gNavOpener.click();
                    }
                }
            });

            document.addEventListener('click', (e) => {
                if (!e.target.closest('#gNavOpener,#gNav')) {
                    if (this.isNavOpen) {
                        gNavOpener.click();
                    }
                }
            });

            document.querySelectorAll('#gNav a').forEach((v, i) => {
                v.addEventListener('click', (e) => {
                    if (this.isNavOpen) {
                        gNavOpener.click();
                    }
                });
            });
        }
    }

    initMegaMenu() {
        const parents = document.querySelectorAll('.js-mmParentItem');
        const buttons = document.querySelectorAll('.js-mmParentBtn');
        const menus = document.querySelectorAll('.js-mMenu');
        const closeBtn = document.querySelectorAll('.js-closeBtn');
        let menuIndex = 0;
        buttons.forEach((button) => {
            button.setAttribute('aria-expanded', false);
            const menu = button.nextElementSibling;
            if (menu && menu.classList.contains('js-mMenu')) {
                button.setAttribute('aria-controls', 'mMenu' + menuIndex);
                menu.setAttribute('aria-hidden', true);
                menu.setAttribute('id', 'mMenu' + menuIndex);
                menuIndex++;
            }
        });
        closeBtn.forEach((btn) => {
            const menu = btn.closest('.js-mMenu');
            if (menu && menu.id) {
                btn.setAttribute('aria-controls', menu.id);
            }
        });
        const eventType = 'click';
        let isMenuOpen = false;
        const toggleMenu = (button, menu, isOpen) => {
            button.setAttribute('aria-expanded', isOpen);
            menu.setAttribute('aria-hidden', !isOpen);
            button.classList.toggle('is-active', isOpen);
            menu.classList.toggle('is-open', isOpen);
            if (util.isRespMode) {
                menu.style.height = isOpen ? `${menu.scrollHeight}px` : null;
            }
            isMenuOpen = isOpen;
        };
        const closeAllMenus = () => {
            buttons.forEach((b) => toggleMenu(b, b.nextElementSibling, false));
        };
        const handleMenuToggle = (e) => {
            e.preventDefault();
            const button = e.currentTarget;
            const menu = button.nextElementSibling;
            const isOpen = !button.classList.contains('is-active');
            closeAllMenus();
            if (isOpen) toggleMenu(button, menu, true);
        };
        parents.forEach((parent) => {
            const menu = parent.querySelector('.js-mMenu');
            if (menu && menu.id && !util.isRespMode) {
                new azlib.FocusLoop(`#${menu.id}`).isRun = true;
            }
            parent.querySelectorAll('.js-mmParentBtn').forEach((button) => {
                button.addEventListener(eventType, handleMenuToggle);
            });
        });
        document.addEventListener('keydown', (e) => {
            if (e.key === 'Escape') closeAllMenus();
        });
        if (util.isRespMode) {
            const gNavOpener = document.getElementById('gNavOpener');
            if (gNavOpener) {
                gNavOpener.addEventListener('click', closeAllMenus);
            }
        }
        document.querySelectorAll('#gNav .js-closeBtn').forEach((btn) => {
            btn.addEventListener('click', () => {
                const activeButton = document.querySelector(
                    '.js-mmParentBtn.is-active'
                );
                if (activeButton) {
                    activeButton.focus();
                }
                closeAllMenus();
            });
        });
    }

    addSpMenu() {
        const gNav = document.getElementById('gNav');
        if (!gNav) {
            return;
        }

        gNav.setAttribute('aria-hidden', true);
    }
}

const util = new azlib.Utilities({
});
const leftPanelMenu = new LeftPanelMenu();

document.addEventListener('DOMContentLoaded', () => {
    util.init();
    leftPanelMenu.init();
});